<template>
    <span role="alert" class="invalid-feedback" v-if="error">
        <strong>{{ error }}</strong>
    </span>
</template>

<script>
	export default {
		props: {
			'name': String,
			'errors': Object,
			'text': String,
			index:{
				default: null,
			},
		},
		computed: {
			error: function () {
				let name = this.name;
				if (this.text) {
					return this.text;
				}

				if (this.index !== null) {
					name = this.index + '.' + this.name;
				}

				if (this.errors[name]) {
					return this.errors[name][0];
				}

				return null;
			}
		},
	};
</script>